var pug = require("!../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"application-actions clearfix\"\u003E\u003Cdiv class=\"application-actions__previous\"\u003E\u003Cbutton class=\"btn btn-tertiary btn-previous\" type=\"button\" ng-click=\"previousStep()\"\u003Eback\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"application-actions__next\"\u003E\u003Cbutton class=\"btn btn-info\" type=\"submit\" value=\"next\"\u003E\u003Cspan ng-if=\"!isLastStep\"\u003Enext\u003C\u002Fspan\u003E\u003Cspan ng-if=\"isLastStep\"\u003Esubmit\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/partials/actions.pug
// module id = 45
// module chunks = 0